import type { Dispatcher } from "hooks";
import { ApiState } from "infrastructure/api";
import { Repository as BaseRepository, RepositoryActionType } from "../../Repository";
import type { NotificationsRepository, NotificationsRepositoryState } from "./types";

export class Repository<
    TNotification extends object
> extends BaseRepository<NotificationsRepositoryState<TNotification>> implements NotificationsRepository<TNotification> {
    public constructor(
        public readonly state: NotificationsRepositoryState<TNotification>,
        protected readonly dispatch: Dispatcher<RepositoryActionType>,
        public readonly fetchHandler: (searchQueryParams?: string) => Promise<NotificationsRepositoryState<TNotification>['data']>,
    ) {
        super(state, dispatch);
    }

    public get data() {
        return this.state.data;
    }

    public override get isRepositoryEmpty() {
        return Boolean(
            [ApiState.Succeeded]
                .includes(this.state.apiState) &&
            !this.state.data
        );
    }
}
